
import { AssetQualityLevel } from "@nolimitcity/slot-game/bin/asset/Asset";
import { APIEvent } from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import { Device } from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { ApiPlugin } from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import { NolimitConfig } from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import { SlotApiAdapter } from "./SlotApiAdapter";

export enum AssetsQualitySetting {
    NONE = 0,
    LOW,
    MEDIUM,
    HIGH
}

export class GameSetting extends SlotApiAdapter {

    public static readonly DEFAULT_DEV_MODE:boolean = false;

    private static _quality:AssetsQualitySetting;
    private static _smartLoading:boolean;
    private static _replayMode:boolean;

    private static _instance:GameSetting;

    private static _betType:string;

    constructor(api:ApiPlugin) {
        super(api);

        
        GameSetting._instance = this;   
        GameSetting._quality = GameSetting.getQualitySetting(this.getQuality());
        GameSetting._smartLoading = this.getSmartLoading();
        GameSetting._replayMode = this.getReplayMode();

        api.events.on(APIEvent.BET,(data:any) => { GameSetting._betType = data.featureName; });
    }

    private static getQualitySetting(value:string):AssetsQualitySetting {
        switch(value) {
            case "high":
                return AssetsQualitySetting.HIGH;
            case "medium":
                return AssetsQualitySetting.MEDIUM;
            case "low":
                return AssetsQualitySetting.LOW;
            default:
                return AssetsQualitySetting.NONE;
        }
    }


    public static get betType():string{
        return this._betType;
    }

    public static get quality():AssetsQualitySetting {
        return GameSetting._quality;
    }

    public static get smartLoading():boolean {
        return GameSetting._smartLoading;
    }

    public static get replayMode():boolean {
        return GameSetting._replayMode;
    }

    public static get isDevMode():boolean {
        return NolimitConfig.isDevMode;
    }

    public static get isFastSpin():boolean {
        if(GameSetting._instance) {
            return GameSetting._instance.isFastSpin() ?? false;
        } else {
            debugger;
            throw new Error("Error: GameSetting.isFastSpin: GameSetting is not initialized!");
        }
    }

    public static get isSoundEffectsOn():boolean {
        if(GameSetting._instance) {
            return GameSetting._instance.isSoundEffectsOn() ?? false;
        } else {
            debugger;
            throw new Error("Error: GameSetting.isSoundEffectsOn: GameSetting is not initialized!");
        }
    }

    public static get isLeftHanded():boolean {
        if(GameSetting._instance) {
            return GameSetting._instance.isLeftHanded() ?? false;
        }
        debugger;
        throw new Error("Error: GameSetting.isLeftHanded: GameSetting is not initialized!");
    }
    
    public static getDefaultQualities():AssetQualityLevel[] {
        if(GameSetting.smartLoading == false) {
            switch(GameSetting.quality) {
                case AssetsQualitySetting.HIGH:
                    return [AssetQualityLevel.HIGH];
                case AssetsQualitySetting.MEDIUM:
                    return [AssetQualityLevel.MEDIUM];
                case AssetsQualitySetting.LOW:
                    return [AssetQualityLevel.LOW];
                default:
                    return NolimitApplication.apiPlugin.options.device === Device.MOBILE ? [AssetQualityLevel.MEDIUM] : [AssetQualityLevel.HIGH];
            }
        }

        switch(GameSetting.quality) {
            case AssetsQualitySetting.HIGH:
                return [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH];
            case AssetsQualitySetting.MEDIUM:
                return [AssetQualityLevel.LOW, AssetQualityLevel.MEDIUM];
            case AssetsQualitySetting.LOW:
                return [AssetQualityLevel.LOW];
            default:
                return NolimitApplication.apiPlugin.options.device === Device.MOBILE ? [AssetQualityLevel.LOW, AssetQualityLevel.MEDIUM] : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH];
        }
    }
}